module.exports = __webpack_public_path__ + "img/YouTube.efc3f9bd.svg";